/**
 * Friendly guest aliases (PRD §7).
 *
 * Rules:
 *  - never derived from anything personally identifying
 *  - football-flavoured and self-deprecating, matching the brand voice
 *  - short enough to fit a leaderboard row on a 320px screen
 *
 * Examples: CuriousPunt42, RookieQB17, FirstDownFox, ConfusedCoach81
 */

const ADJECTIVES = Object.freeze([
  "Curious",
  "Rookie",
  "Confused",
  "Hopeful",
  "Puzzled",
  "Brave",
  "Casual",
  "Sneaky",
  "Cheerful",
  "Lucky",
  "Nervous",
  "Bold",
  "Sleepy",
  "Chaotic",
  "Polite",
  "Wandering",
  "Snacking",
  "Optimistic",
  "Baffled",
  "Determined",
]);

const NOUNS = Object.freeze([
  "Punt",
  "QB",
  "Fox",
  "Coach",
  "Tackle",
  "Huddle",
  "Blitz",
  "Kicker",
  "Fumble",
  "Endzone",
  "Sideline",
  "Referee",
  "Nacho",
  "Couch",
  "Timeout",
  "Touchdown",
  "Lineman",
  "Whistle",
  "Snap",
  "Pylon",
]);

const randomInt = (maxExclusive) => Math.floor(Math.random() * maxExclusive);
const pick = (list) => list[randomInt(list.length)];

/**
 * @param {() => number} [rng] injectable 0..1 generator, for deterministic tests
 * @returns {string} e.g. "CuriousPunt42"
 */
export function generateAlias(rng) {
  if (typeof rng === "function") {
    const adjective = ADJECTIVES[Math.floor(rng() * ADJECTIVES.length)];
    const noun = NOUNS[Math.floor(rng() * NOUNS.length)];
    const number = 10 + Math.floor(rng() * 90);
    return `${adjective}${noun}${number}`;
  }

  return `${pick(ADJECTIVES)}${pick(NOUNS)}${10 + randomInt(90)}`;
}

/**
 * Trim a signed-in user's display name down to something leaderboard-safe.
 * Falls back to a generated alias when there is nothing usable.
 */
export function aliasFromDisplayName(displayName) {
  const first = String(displayName ?? "")
    .trim()
    .split(/\s+/)[0]
    .replace(/[^\p{L}\p{N}]/gu, "");

  return first.length >= 2 ? first.slice(0, 16) : generateAlias();
}

export const ALIAS_WORDS = Object.freeze({ ADJECTIVES, NOUNS });
